/**
 * Show the camera / QR-scan affordance across the system: the global header
 * button and every per-feature camera button. Disabled by default; set
 * `NEXT_PUBLIC_QR_SCANNER_ENABLED=true` to expose camera-based QR scanning
 * (hardware-keystroke scanning is unaffected either way).
 */
export const IS_QR_SCANNER_ENABLED =
  process.env.NEXT_PUBLIC_QR_SCANNER_ENABLED === 'true';
